export enum EDayType {
  Weekday = 'WEEKDAY',
  Weekend = 'WEEKEND',
}
export const dayTypeMapping: Record<EDayType, string> = {
  [EDayType.Weekday]: 'Будни',
  [EDayType.Weekend]: 'Выходные',
};
